<template>
  <section class="chat_audit_set">
    <h3>{{ $t('lang.k_344001') }}</h3>
    <div class="radio-group-wrapper">
      <vh-radio-group v-model="radioValue">
        <vh-radio label="1" class="custom-radio">
          <span class="radio-content">{{ $t('lang.k_344002') }}</span>
        </vh-radio>
        <vh-radio label="0" class="custom-radio">
          <span class="radio-content">{{ $t('lang.k_344003') }}</span>
        </vh-radio>
      </vh-radio-group>
    </div>

    <div class="button-wrapper">
      <vh-button type="primary" round class="save-button" @click="save">
        {{ $t('lang.k_344004') }}
      </vh-button>
    </div>

    <div class="notice">
      <div class="notice-title">{{ $t('lang.k_344005') }}</div>
      <div class="notice-content">
        <p class="notice-item">{{ $t('lang.k_344006') }}</p>
        <p class="notice-item">{{ $t('lang.k_344007') }}</p>
        <pc-preview class="notice-item">{{ $t('lang.k_344008') }}</pc-preview>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    data() {
      return {
        radioValue: '1'
      };
    },
    methods: {
      getAuditSet() {
        this.$fetch('getChatAuditSet', { config_type: '10', config_subtype: '4' }).then(res => {
          if (res.code == 200) {
            this.radioValue = res.data?.config_value
              ? JSON.parse(res.data.config_value).bucket_switch
              : '1';
          }
        });
      },
      save() {
        this.$fetch('saveChatAuditSet', {
          config_type: '10',
          config_subtype: '4',
          config_value: JSON.stringify({ bucket_switch: this.radioValue })
        })
          .then(res => {
            if (res.code == 200) {
              this.$vhMessage.success(this.$t('lang.k_344009'));
            }
          })
          .catch(error => {
            this.$vhMessage.error(error.message || this.$t('lang.k_344010'));
          });
      }
    },
    mounted() {
      this.getAuditSet();
    }
  };
</script>
<style scoped>
  .chat_audit_set {
    padding: 20px;
    background-color: #ffffff;
    border-radius: 4px;
  }

  h3 {
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
  }

  .radio-group-wrapper {
    margin-bottom: 30px;
  }

  .custom-radio {
    margin-bottom: 15px;
    line-height: 24px;
  }

  .custom-radio:last-child {
    margin-bottom: 0;
  }

  .radio-content {
    font-size: 14px;
    color: #333333;
  }

  .button-wrapper {
    margin-bottom: 20px;
    text-align: center;
  }

  .save-button {
    width: 120px;
  }

  .notice {
    margin-top: 20px;
    padding: 10px;
    font-size: 12px;
    color: #999999;
    line-height: 17px;
  }

  .notice-title {
    margin-bottom: 8px;
    font-weight: 500;
  }

  .notice-item:last-child {
    margin-bottom: 0;
  }
</style>
